import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Tooltip, Snackbar } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

/**
 * ShareButtons — Copy-link share button for blog & Financlopedia.
 * @param {string} url - Full URL to share (defaults to current page)
 */
export default function ShareButtons({ url }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [shareUrl, setShareUrl] = useState(url || '');

  useEffect(() => {
    if (!url) setShareUrl(window.location.href);
  }, [url]);

  const handleCopyLink = useCallback(() => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
    });
  }, [shareUrl]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={t('share.copyLink', 'Copiar enlace')}>
        <IconButton
          onClick={handleCopyLink}
          sx={{
            color: '#5F6B7A',
            bgcolor: '#F7F9FC',
            minWidth: 44,
            minHeight: 44,
            '&:hover': { bgcolor: '#E6E9EE' },
          }}
          aria-label="Copiar enlace"
        >
          <ContentCopyIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>

      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        message={t('share.copied', 'Enlace copiado')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Box>
  );
}
